export const BOT = {
    DELAY: 3000,
}